import { writable, derived } from "svelte/store";

const storeGlobal = writable ({
  darkMode: false,
  showItems: 10,
  showNav: false,
  showFilter: false,
  showDetails: false,
  searchPigment: false,
  detailColor: [],
  searchTerm: '',
  searchFilter: {
    vegan: false,
    lightfast: false,
    singlePigment: false,
    producer: 'All',
    medium: 'All',
    staining: 'All',
    transparency: 'All',
    granulation: 'All',
    quality: 'All'
  }
})

const store = {
  subscribe: storeGlobal.subscribe,
  updateItem: (item, value) => {
    storeGlobal.update( currentValues => {
      return {...currentValues, [item]:value}
    })
  }
};

// Filters
export const storeFilters = derived (storeGlobal, ($filter) => {
  let filters = {};

  if($filter.searchFilter.vegan) { filters.vegan = $filter.searchFilter.vegan}
  if($filter.searchFilter.lightfast) { filters.lightfast = $filter.searchFilter.lightfast}
  if($filter.searchFilter.singlePigment) { filters.singlePigment = $filter.searchFilter.singlePigment}
  if($filter.searchFilter.producer !== 'All') { filters.producer = $filter.searchFilter.producer; }
  if($filter.searchFilter.medium !== 'All') { filters.medium = $filter.searchFilter.medium; }
  if($filter.searchFilter.staining !== 'All') { filters.staining = $filter.searchFilter.staining; }
  if($filter.searchFilter.transparency !== 'All') { filters.transparency = $filter.searchFilter.transparency; }
  if($filter.searchFilter.granulation !== 'All') { filters.granulation = $filter.searchFilter.granulation; }
  if($filter.searchFilter.quality !== 'All') { filters.quality = $filter.searchFilter.quality; }

  return filters;
})


export default store;
